(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function toast(msg) {
    var t = $('#sg-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  function money(cents) {
    var fmt = window.SG_MONEY_FORMAT || '${{amount}}';
    function delim(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[0] + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, ',', '.');
      }
    });
  }

  var cds = $$('.cd[data-end]');
  if (cds.length) {
    var end = new Date(cds[0].getAttribute('data-end'));
    var tick = function () {
      var ms = end - new Date(), txt;
      if (isNaN(ms)) { txt = ''; }
      else if (ms <= 0) { txt = 'sale over'; }
      else {
        var p = function (n) { return String(n).padStart(2, '0'); };
        var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
        txt = (d ? d + 'd ' : '') + p(h) + 'h ' + p(m) + 'm ' + p(s) + 's';
      }
      cds.forEach(function (e) { e.textContent = txt; });
    };
    tick(); setInterval(tick, 1000);
  }

  var mainImg = $('#sg-mainimg');
  $$('.thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      if (mainImg) { mainImg.src = b.getAttribute('data-src'); mainImg.alt = b.getAttribute('data-alt') || ''; }
    });
  });

  var form = $('#sg-form');
  if (form) {
    var input = $('#sg-variant', form);
    var prot = $('#sg-prot');
    var addBtn = $('#sg-add');
    var current = $('.bundle[aria-checked="true"]', form);

    var render = function () {
      if (!current) return;
      var cents = parseInt(current.getAttribute('data-cents'), 10);
      $('#sg-now').textContent = current.getAttribute('data-price');
      var was = current.getAttribute('data-was'), pct = current.getAttribute('data-pct');
      var wasEl = $('#sg-was'), saveEl = $('#sg-save');
      if (was) { wasEl.textContent = was; wasEl.hidden = false; saveEl.textContent = 'SAVE ' + pct + '%'; saveEl.hidden = false; }
      else { wasEl.hidden = true; saveEl.hidden = true; }
      if (prot && prot.checked) cents += parseInt(prot.getAttribute('data-cents'), 10);
      $('#sg-total').textContent = money(cents);
    };

    $$('.bundle', form).forEach(function (b) {
      b.addEventListener('click', function () {
        current = b;
        $$('.bundle', form).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        input.value = b.getAttribute('data-id');
        render();
      });
    });
    if (prot) prot.addEventListener('change', render);
    render();

    form.addEventListener('submit', function (e) {
      if (!prot || !prot.checked) return;
      e.preventDefault();
      addBtn.disabled = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: parseInt(input.value, 10), quantity: 1 },
          { id: parseInt(prot.getAttribute('data-id'), 10), quantity: 1 }
        ] })
      }).then(function (r) {
        if (r.ok) { window.location.href = root + 'cart'; }
        else { return r.json().then(function (j) { toast(j.description || 'Could not add to cart. Please try again.'); addBtn.disabled = false; }); }
      }).catch(function () { toast('Could not add to cart. Please try again.'); addBtn.disabled = false; });
    });
  }

  var copy = $('#sg-copy');
  if (copy) {
    copy.addEventListener('click', function () {
      var el = $('#sg-email'), t = el.textContent.trim();
      var sel = function () { var r = document.createRange(); r.selectNodeContents(el); var s = getSelection(); s.removeAllRanges(); s.addRange(r); toast('Email selected, press copy'); };
      if (navigator.clipboard) navigator.clipboard.writeText(t).then(function () { toast('Email copied'); }, sel); else sel();
    });
  }
})();
